import { RouteConfig } from 'vue-router'

const Info = () => import('../../views/payment/Info.vue')
const Qrcode = () => import('../../views/payment/Qrcode.vue')

export const infoRoute: RouteConfig = {
  path: '/payment/info',
  name: 'payment_info',
  component: Info,
  props: (route) => ({ ...route.query, ...route.params, orderId: route.query.order_id }),
  meta: {
    title: '二维码支付',
  },
}

export const qrcodeRoute: RouteConfig = {
  path: '/payment/qrcode',
  name: 'payment_qrcode',
  component: Qrcode,
  props: (route) => ({ ...route.query, ...route.params, orderId: route.query.order_id }),
  meta: {
    title: '二维码支付',
  },
}

export default [infoRoute, qrcodeRoute]
